import type { IconProps } from './types';
import './icons.css';

export default function Batches({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-copy ${className || ''}`}
    >
      <path
        d="M10 18C10 18.5523 10.4477 19 11 19H18C18.5523 19 19 18.5523 19 18V11C19 10.4477 18.5523 10 18 10H17V9H18C19.1046 9 20 9.89543 20 11V18C20 19.1046 19.1046 20 18 20H11C9.89543 20 9 19.1046 9 18V17H10V18Z"
        fill="#171819"
      />
      <path
        d="M7 15C7 15.5523 7.44772 16 8 16H15C15.5523 16 16 15.5523 16 15V8C16 7.44772 15.5523 7 15 7H14V6H15C16.1046 6 17 6.89543 17 8V15C17 16.1046 16.1046 17 15 17H8C6.89543 17 6 16.1046 6 15V14H7V15Z"
        fill="#171819"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4H5C4.44772 4 4 4.44772 4 5V12C4 12.5523 4.44772 13 5 13H12C12.5523 13 13 12.5523 13 12V5C13 4.44772 12.5523 4 12 4ZM5 3C3.89543 3 3 3.89543 3 5V12C3 13.1046 3.89543 14 5 14H12C13.1046 14 14 13.1046 14 12V5C14 3.89543 13.1046 3 12 3H5Z"
        fill="#171819"
      />
    </svg>
  );
}
